import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import CheckMarkIcon from '../svg-icons/check-mark-icon';
import './style.css';
var MenuItem = /*#__PURE__*/function (_React$Component) {
  _inherits(MenuItem, _React$Component);
  var _super = _createSuper(MenuItem);
  function MenuItem() {
    var _this;
    _classCallCheck(this, MenuItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.onClick = function (e) {
      _this.props.onClick(e);
    };
    return _this;
  }
  _createClass(MenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        itemClass = _this$props.itemClass,
        iconClass = _this$props.iconClass,
        isChecked = _this$props.isChecked;
      var containerClass = "seafile-menu-item ".concat(itemClass || '');
      var itemIconClass = "menu-item-icon ".concat(iconClass || '');
      return /*#__PURE__*/React.createElement("span", {
        className: containerClass,
        onClick: this.onClick
      }, /*#__PURE__*/React.createElement("span", {
        className: itemIconClass
      }), /*#__PURE__*/React.createElement("span", {
        className: "menu-item-name"
      }, children), isChecked && /*#__PURE__*/React.createElement(CheckMarkIcon, {
        className: "checked-icon",
        width: 13,
        color: "#aaa"
      }));
    }
  }]);
  return MenuItem;
}(React.Component);
export default MenuItem;